// extracted by mini-css-extract-plugin
export default {"container":"Section_container__Bel2b","section":"Section_section__kylri"};